import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

export interface ProductListLoadMoreState {
    loadMore: boolean;
}
const initialState: ProductListLoadMoreState = {
    loadMore: false,
};

const reducer = {
    "Custom/ProductList/SetLoadMore": (draft: Draft<ProductListLoadMoreState>, action: { result: boolean }) => {
        draft.loadMore = action.result;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
